import * as yup from 'yup'
import { ValidationError } from 'yup'
import {
    buildFixedDenomSchema,
    buildMinMaxDenomSchema,
} from '@/src/modules/build-a-card/validations/schemas'

const DENOMINATION_PATH = 'denomination'

const ValidateDenomSchema = (
    minDenom: number,
    maxDenom: number,
    fixedDenoms: number[] | undefined
) => {
    if (Array.isArray(fixedDenoms) && fixedDenoms?.length > 0) {
        const fixedSchema = buildFixedDenomSchema(fixedDenoms)
        return yup.object(fixedSchema)
    }

    const minMaxSchema = buildMinMaxDenomSchema(minDenom, maxDenom)
    return yup.object(minMaxSchema)
}

type TDenomChangeProps = {
    denom: string
    setDenomination: Function
    formErrors: ValidationError[]
    setFormErrors: Function
    minDenom: number
    maxDenom: number
    fixedDenoms?: number[]
}

// set denomination and validate it is valid
export function validateDenomOnChange({
    denom,
    setDenomination,
    formErrors,
    setFormErrors,
    minDenom,
    maxDenom,
    fixedDenoms,
}: TDenomChangeProps) {
    // remove negative value if any
    const cleanedDenom = denom.replace(/-/g, '')
    setDenomination(cleanedDenom)

    const existingDenomError = formErrors?.find(
        (error) => error.path === DENOMINATION_PATH
    )

    ValidateDenomSchema(minDenom, maxDenom, fixedDenoms)
        .validate({
            denomination: cleanedDenom,
        })
        .then(() => {
            if (!existingDenomError) {
                return
            }

            const nonDenomErrors =
                formErrors?.filter(
                    (error) => error.path !== DENOMINATION_PATH
                ) ?? []

            setFormErrors(nonDenomErrors)
        })
        .catch((err: ValidationError) => {
            if (!existingDenomError) {
                setFormErrors((prev: ValidationError[]) => {
                    let array = [...prev]
                    array.push(err)
                    return array
                })
            }
        })
}
